import { handleErrors, HTTP_CODE, ERROR_HANDLING_EXPERIENCE } from '../../utils/redirector-utils';

export const isInvalidPackageId = ({ packageId }) => {
  if (!/^package_/.test(packageId)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `invalid package id: ${packageId}`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT
    };
  }

  return null;
};

export const hasNoPackageData = ({ data, packageId }) => {
  if (!data) return null;

  if (
    (packageId && !data.packages)
    || data?.packages?.length === 0
    || !data?.packages?.[0]?.products?.[0]?.identifiers?.itemId
    || !data?.packages?.[0]?.metadata?.packageId
  ) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `no package data found for ${packageId}`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT,
    };
  }
  return null;
};
